import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteLocation, ApiGetLocation, ApiGetLocationList, ApiInsertLocation, ApiUpdateLocation } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function LocationService() {
    const { showFail } = useModal()

    const { fetch: apiGetLocationList } = useFetch(ApiGetLocationList)
    const { fetch: apiGetLocationById } = useFetch(ApiGetLocation)
    const { fetch: apiInsertLocation } = useFetch(ApiInsertLocation)
    const { fetch: apiUpdateLocation } = useFetch(ApiUpdateLocation)
    const { fetch: apiDeleteLocation } = useFetch(ApiDeleteLocation)
 
    const fetchLocationList = async(locationName, status, pageSize, pageIndex) => {
        const res = await apiGetLocationList({
            data: {
                locationName,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchLocationById = async(locationId) => {
        const res = await apiGetLocationById({
            data: {
                locationId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertLocation = async(locationName, address, city, province, phone) => {
        const res = await apiInsertLocation({
            data: {
                locationName, 
                address, 
                city, 
                province, 
                phone
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateLocation = async(locationId, locationName, address, city, province, phone) => {
        const res = await apiUpdateLocation({
            data: {
                locationId,
                locationName, 
                address, 
                city, 
                province, 
                phone
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteLocation = async(locationId, status) => {
        const res = await apiDeleteLocation({
            data: {
                locationId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchLocationList,
        fetchLocationById,
        fetchInsertLocation,
        fetchUpdateLocation,
        fetchDeleteLocation
    }
}